export enum TxpSettingsDialogViewStates {
    Saving,
    Shown,
    Hidden,
}

export default TxpSettingsDialogViewStates;
